import { render } from "./CatTestsView.vue?vue&type=template&id=1c107bba&scoped=true"
import script from "./CatTestsView.vue?vue&type=script&lang=js"
export * from "./CatTestsView.vue?vue&type=script&lang=js"

import "./CatTestsView.vue?vue&type=style&index=0&id=1c107bba&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/fife-cz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c107bba"]])

export default __exports__